@file:OptIn(InternalResourceApi::class)

package gero.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/gero.composeapp.generated.resources/"

@delegate:ResourceContentHash(401_959_692)
internal val Res.string.reminder_open_exact_alarm_settings: StringResource by lazy {
      StringResource("string:reminder_open_exact_alarm_settings", "reminder_open_exact_alarm_settings", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 236339, 74),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 233647, 74),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 234310, 86),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 224843, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 219339, 66),
      ))
    }

@delegate:ResourceContentHash(1_353_559_915)
internal val Res.string.reminder_open_permissions: StringResource by lazy {
      StringResource("string:reminder_open_permissions", "reminder_open_permissions", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 236414, 65),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 233722, 57),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 234397, 65),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 224918, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 219406, 57),
      ))
    }

@delegate:ResourceContentHash(1_563_667_688)
internal val Res.string.reminder_settings_choose: StringResource by lazy {
      StringResource("string:reminder_settings_choose", "reminder_settings_choose", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 236480, 52),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 233780, 52),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 234463, 52),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 224972, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 219464, 52),
      ))
    }

@delegate:ResourceContentHash(448_865_467)
internal val Res.string.reminder_settings_desc: StringResource by lazy {
      StringResource("string:reminder_settings_desc", "reminder_settings_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 236533, 118),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 233833, 86),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 234516, 106),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 225025, 86),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 219517, 102),
      ))
    }

@delegate:ResourceContentHash(904_526_684)
internal val Res.string.reminder_settings_title: StringResource by lazy {
      StringResource("string:reminder_settings_title", "reminder_settings_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 236652, 55),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 233920, 59),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 234623, 51),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 225112, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 219620, 51),
      ))
    }

@delegate:ResourceContentHash(1_001_726_039)
internal val Res.string.reminder_settings_toggle_desc: StringResource by lazy {
      StringResource("string:reminder_settings_toggle_desc", "reminder_settings_toggle_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 236708, 129),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 233980, 121),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 234675, 117),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 225164, 117),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 219672, 101),
      ))
    }

@delegate:ResourceContentHash(-561_497_778)
internal val Res.string.reminder_settings_toggle_title: StringResource by lazy {
      StringResource("string:reminder_settings_toggle_title", "reminder_settings_toggle_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 236838, 62),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 234102, 58),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 234793, 58),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 225282, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 219774, 58),
      ))
    }

@delegate:ResourceContentHash(-624_567_679)
internal val Res.string.remove_hearts_btn: StringResource by lazy {
      StringResource("string:remove_hearts_btn", "remove_hearts_btn", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 236901, 41),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 234161, 45),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 234852, 41),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 225333, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 219833, 41),
      ))
    }

@delegate:ResourceContentHash(1_890_975_740)
internal val Res.string.repeat_quizzes_hint: StringResource by lazy {
      StringResource("string:repeat_quizzes_hint", "repeat_quizzes_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 236943, 99),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 234207, 107),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 234894, 111),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 225371, 99),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 219875, 91),
      ))
    }

@delegate:ResourceContentHash(160_892_883)
internal val Res.string.request_more_lessons_btn: StringResource by lazy {
      StringResource("string:request_more_lessons_btn", "request_more_lessons_btn", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 237043, 104),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 234315, 116),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 235006, 140),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 225471, 104),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 219967, 116),
      ))
    }

@delegate:ResourceContentHash(1_002_422_182)
internal val Res.string.request_more_lessons_email_body: StringResource by lazy {
      StringResource("string:request_more_lessons_email_body", "request_more_lessons_email_body", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 237148, 255),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 234432, 251),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 235147, 407),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 225576, 227),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 220084, 219),
      ))
    }

@delegate:ResourceContentHash(496_726_830)
internal val Res.string.request_more_lessons_email_subject: StringResource by lazy {
      StringResource("string:request_more_lessons_email_subject", "request_more_lessons_email_subject", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 237404, 110),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 234684, 106),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 235555, 102),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 225804, 98),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 220304, 90),
      ))
    }

@delegate:ResourceContentHash(-441_962_744)
internal val Res.string.reset_btn: StringResource by lazy {
      StringResource("string:reset_btn", "reset_btn", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 237515, 37),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 234791, 33),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 235658, 37),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 225903, 25),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 220395, 25),
      ))
    }

@delegate:ResourceContentHash(-570_848_282)
internal val Res.string.reset_data_btn: StringResource by lazy {
      StringResource("string:reset_data_btn", "reset_data_btn", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 237553, 50),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 234825, 46),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 235696, 58),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 225929, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 220421, 38),
      ))
    }

@delegate:ResourceContentHash(-779_459_263)
internal val Res.string.reset_data_confirm: StringResource by lazy {
      StringResource("string:reset_data_confirm", "reset_data_confirm", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 237604, 50),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 234872, 50),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 235755, 54),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 225968, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 220460, 42),
      ))
    }

@delegate:ResourceContentHash(997_529_914)
internal val Res.string.reset_data_dialog_text: StringResource by lazy {
      StringResource("string:reset_data_dialog_text", "reset_data_dialog_text", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 237655, 106),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 234923, 102),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 235810, 102),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 226011, 98),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 220503, 90),
      ))
    }

@delegate:ResourceContentHash(-570_848_282)
internal val Res.string.reset_data_dialog_title: StringResource by lazy {
      StringResource("string:reset_data_dialog_title", "reset_data_dialog_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 237762, 59),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 235026, 55),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 235913, 67),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 226110, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 220594, 47),
      ))
    }

@delegate:ResourceContentHash(605_225_182)
internal val Res.string.restore_purchases_btn: StringResource by lazy {
      StringResource("string:restore_purchases_btn", "restore_purchases_btn", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 237822, 61),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 235082, 53),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 235981, 57),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 226158, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 220642, 53),
      ))
    }

@delegate:ResourceContentHash(534_132_138)
internal val Res.string.review_prompt_btn_later: StringResource by lazy {
      StringResource("string:review_prompt_btn_later", "review_prompt_btn_later", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 237884, 43),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 235136, 47),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 236039, 59),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 226216, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 220696, 47),
      ))
    }

@delegate:ResourceContentHash(1_971_622_358)
internal val Res.string.review_prompt_btn_rate: StringResource by lazy {
      StringResource("string:review_prompt_btn_rate", "review_prompt_btn_rate", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 237928, 54),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 235184, 54),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 236099, 50),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 226264, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 220744, 50),
      ))
    }

@delegate:ResourceContentHash(-477_848_109)
internal val Res.string.review_prompt_feedback: StringResource by lazy {
      StringResource("string:review_prompt_feedback", "review_prompt_feedback", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 237983, 174),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 235239, 154),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 236150, 174),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 226323, 150),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 220795, 138),
      ))
    }

@delegate:ResourceContentHash(1_709_418_148)
internal val Res.string.review_prompt_title: StringResource by lazy {
      StringResource("string:review_prompt_title", "review_prompt_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 238158, 59),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 235394, 55),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 236325, 55),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 226474, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 220934, 51),
      ))
    }

@delegate:ResourceContentHash(383_901_772)
internal val Res.string.rule_aggettivi_card_1: StringResource by lazy {
      StringResource("string:rule_aggettivi_card_1", "rule_aggettivi_card_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 238218, 213),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 235450, 201),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 236381, 189),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 226526, 189),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 220986, 181),
      ))
    }

@delegate:ResourceContentHash(-224_330_753)
internal val Res.string.rule_aggettivi_card_2: StringResource by lazy {
      StringResource("string:rule_aggettivi_card_2", "rule_aggettivi_card_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 238432, 201),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 235652, 181),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 236571, 185),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 226716, 181),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 221168, 193),
      ))
    }

@delegate:ResourceContentHash(487_875_967)
internal val Res.string.rule_aggettivi_card_3: StringResource by lazy {
      StringResource("string:rule_aggettivi_card_3", "rule_aggettivi_card_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 238634, 261),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 235834, 281),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 236757, 273),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 226898, 257),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 221362, 245),
      ))
    }

@delegate:ResourceContentHash(1_076_490_568)
internal val Res.string.rule_aggettivi_card_4: StringResource by lazy {
      StringResource("string:rule_aggettivi_card_4", "rule_aggettivi_card_4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 238896, 333),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 236116, 305),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 237031, 309),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 227156, 297),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 221608, 309),
      ))
    }

@delegate:ResourceContentHash(1_061_977_766)
internal val Res.string.rule_aggettivi_ex_nfr: StringResource by lazy {
      StringResource("string:rule_aggettivi_ex_nfr", "rule_aggettivi_ex_nfr", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 239313, 49),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 236497, 65),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 237424, 65),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 227529, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 221997, 65),
      ))
    }

@delegate:ResourceContentHash(1_916_816_992)
internal val Res.string.rule_aggettivi_ex_nfrt: StringResource by lazy {
      StringResource("string:rule_aggettivi_ex_nfrt", "rule_aggettivi_ex_nfrt", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 239230, 82),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 236422, 74),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 237341, 82),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 227454, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 221918, 78),
      ))
    }

@delegate:ResourceContentHash(612_202_006)
internal val Res.string.rule_aggettivi_ex_rmt_nfr: StringResource by lazy {
      StringResource("string:rule_aggettivi_ex_rmt_nfr", "rule_aggettivi_ex_rmt_nfr", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 239363, 89),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 236563, 89),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 237490, 89),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 227595, 85),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 222063, 81),
      ))
    }

@delegate:ResourceContentHash(789_678_655)
internal val Res.string.rule_aggettivi_ex_rmtw_nfrw: StringResource by lazy {
      StringResource("string:rule_aggettivi_ex_rmtw_nfrw", "rule_aggettivi_ex_rmtw_nfrw", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 239453, 107),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 236653, 107),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 237580, 107),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 227681, 103),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 222145, 99),
      ))
    }

@delegate:ResourceContentHash(1_295_829_075)
internal val Res.string.rule_aggettivi_ex_smsw_iqr: StringResource by lazy {
      StringResource("string:rule_aggettivi_ex_smsw_iqr", "rule_aggettivi_ex_smsw_iqr", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 239561, 94),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 236761, 82),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 237688, 86),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 227785, 82),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 222245, 82),
      ))
    }

@delegate:ResourceContentHash(-1_059_437_319)
internal val Res.string.rule_aggettivi_ex_st_nfrt: StringResource by lazy {
      StringResource("string:rule_aggettivi_ex_st_nfrt", "rule_aggettivi_ex_st_nfrt", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 239656, 85),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 236844, 85),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 237775, 89),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 227868, 85),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 222328, 81),
      ))
    }

@delegate:ResourceContentHash(1_874_661_607)
internal val Res.string.rule_aggettivi_ex_swt_nfrwt: StringResource by lazy {
      StringResource("string:rule_aggettivi_ex_swt_nfrwt", "rule_aggettivi_ex_swt_nfrwt", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 239742, 99),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 236930, 103),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 237865, 107),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 227954, 99),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 222410, 95),
      ))
    }

@delegate:ResourceContentHash(-1_386_927_292)
internal val Res.string.rule_aggettivi_title: StringResource by lazy {
      StringResource("string:rule_aggettivi_title", "rule_aggettivi_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 239842, 48),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 237034, 48),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 237973, 48),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 228054, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 222506, 44),
      ))
    }

@delegate:ResourceContentHash(-482_099_372)
internal val Res.string.rule_dimostrativi_card_1: StringResource by lazy {
      StringResource("string:rule_dimostrativi_card_1", "rule_dimostrativi_card_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 239891, 308),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 237083, 284),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 238022, 292),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 228103, 292),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 222551, 272),
      ))
    }

@delegate:ResourceContentHash(-1_749_818_410)
internal val Res.string.rule_dimostrativi_card_2: StringResource by lazy {
      StringResource("string:rule_dimostrativi_card_2", "rule_dimostrativi_card_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 240200, 132),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 237368, 120),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 238315, 116),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 228396, 120),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 222824, 112),
      ))
    }

@delegate:ResourceContentHash(-657_877_934)
internal val Res.string.rule_dimostrativi_card_3: StringResource by lazy {
      StringResource("string:rule_dimostrativi_card_3", "rule_dimostrativi_card_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 240333, 232),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 237489, 216),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 238432, 224),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 228517, 212),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 222937, 220),
      ))
    }

@delegate:ResourceContentHash(-1_630_357_737)
internal val Res.string.rule_dimostrativi_ex_nn: StringResource by lazy {
      StringResource("string:rule_dimostrativi_ex_nn", "rule_dimostrativi_ex_nn", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 240566, 59),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 237706, 71),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 238657, 75),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 228730, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 223158, 59),
      ))
    }

@delegate:ResourceContentHash(-1_877_266_864)
internal val Res.string.rule_dimostrativi_ex_pn: StringResource by lazy {
      StringResource("string:rule_dimostrativi_ex_pn", "rule_dimostrativi_ex_pn", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 240626, 79),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 237778, 75),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 238733, 91),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 228806, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 223218, 75),
      ))
    }

@delegate:ResourceContentHash(402_005_326)
internal val Res.string.rule_dimostrativi_ex_srw_pn: StringResource by lazy {
      StringResource("string:rule_dimostrativi_ex_srw_pn", "rule_dimostrativi_ex_srw_pn", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 240706, 63),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 237854, 59),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 238825, 67),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 228882, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 223294, 63),
      ))
    }

@delegate:ResourceContentHash(1_697_082_528)
internal val Res.string.rule_dimostrativi_ex_tn: StringResource by lazy {
      StringResource("string:rule_dimostrativi_ex_tn", "rule_dimostrativi_ex_tn", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 240770, 75),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 237914, 71),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 238893, 95),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 228946, 79),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 223358, 71),
      ))
    }

@delegate:ResourceContentHash(91_185_586)
internal val Res.string.rule_dimostrativi_title: StringResource by lazy {
      StringResource("string:rule_dimostrativi_title", "rule_dimostrativi_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 240846, 59),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 237986, 67),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 238989, 71),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 229026, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 223430, 63),
      ))
    }

@delegate:ResourceContentHash(603_577_401)
internal val Res.string.rule_frasi_avverbiali_card_1: StringResource by lazy {
      StringResource("string:rule_frasi_avverbiali_card_1", "rule_frasi_avverbiali_card_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 240906, 240),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 238054, 196),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 239061, 220),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 229094, 220),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 223494, 216),
      ))
    }

@delegate:ResourceContentHash(514_891_384)
internal val Res.string.rule_frasi_avverbiali_card_2: StringResource by lazy {
      StringResource("string:rule_frasi_avverbiali_card_2", "rule_frasi_avverbiali_card_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 241147, 264),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 238251, 264),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 239282, 276),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 229315, 284),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 223711, 256),
      ))
    }

@delegate:ResourceContentHash(-586_738_128)
internal val Res.string.rule_frasi_avverbiali_card_3: StringResource by lazy {
      StringResource("string:rule_frasi_avverbiali_card_3", "rule_frasi_avverbiali_card_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 241412, 284),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 238516, 276),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 239559, 292),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 229600, 276),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 223968, 280),
      ))
    }

@delegate:ResourceContentHash(446_761_007)
internal val Res.string.rule_frasi_avverbiali_card_4: StringResource by lazy {
      StringResource("string:rule_frasi_avverbiali_card_4", "rule_frasi_avverbiali_card_4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 241697, 300),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 238793, 296),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 239852, 308),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 229877, 284),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 224249, 292),
      ))
    }

@delegate:ResourceContentHash(-1_144_676_954)
internal val Res.string.rule_frasi_avverbiali_card_5: StringResource by lazy {
      StringResource("string:rule_frasi_avverbiali_card_5", "rule_frasi_avverbiali_card_5", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 241998, 212),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 239090, 192),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 240161, 232),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 230162, 196),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 224542, 224),
      ))
    }

@delegate:ResourceContentHash(-787_480_785)
internal val Res.string.rule_frasi_avverbiali_ex_iht_pr: StringResource by lazy {
      StringResource("string:rule_frasi_avverbiali_ex_iht_pr", "rule_frasi_avverbiali_ex_iht_pr", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 242211, 87),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 239283, 95),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 240394, 103),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 230359, 91),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 224767, 91),
      ))
    }

@delegate:ResourceContentHash(-948_954_057)
internal val Res.string.rule_frasi_avverbiali_ex_iw: StringResource by lazy {
      StringResource("string:rule_frasi_avverbiali_ex_iw", "rule_frasi_avverbiali_ex_iw", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 242299, 71),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 239379, 79),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 240498, 103),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 230451, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 224859, 79),
      ))
    }

@delegate:ResourceContentHash(510_215_310)
internal val Res.string.rule_frasi_avverbiali_title: StringResource by lazy {
      StringResource("string:rule_frasi_avverbiali_title", "rule_frasi_avverbiali_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 242371, 55),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 239459, 59),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 240602, 63),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 230527, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 224939, 63),
      ))
    }

@delegate:ResourceContentHash(-1_335_474_386)
internal val Res.string.rule_frasi_pseudoverbali_card_1: StringResource by lazy {
      StringResource("string:rule_frasi_pseudoverbali_card_1", "rule_frasi_pseudoverbali_card_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 242427, 351),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 239519, 327),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 240666, 383),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 230587, 331),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 225003, 331),
      ))
    }

@delegate:ResourceContentHash(1_429_530_155)
internal val Res.string.rule_frasi_pseudoverbali_card_2: StringResource by lazy {
      StringResource("string:rule_frasi_pseudoverbali_card_2", "rule_frasi_pseudoverbali_card_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 242779, 243),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 239847, 211),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 241050, 239),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 230919, 219),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 225335, 211),
      ))
    }

@delegate:ResourceContentHash(190_322_144)
internal val Res.string.rule_frasi_pseudoverbali_card_3: StringResource by lazy {
      StringResource("string:rule_frasi_pseudoverbali_card_3", "rule_frasi_pseudoverbali_card_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 243023, 171),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 240059, 159),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 241290, 151),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 231139, 155),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 225547, 159),
      ))
    }

@delegate:ResourceContentHash(489_325_795)
internal val Res.string.rule_frasi_pseudoverbali_card_4: StringResource by lazy {
      StringResource("string:rule_frasi_pseudoverbali_card_4", "rule_frasi_pseudoverbali_card_4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 243195, 187),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 240219, 175),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 241442, 167),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 231295, 163),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 225707, 171),
      ))
    }

@delegate:ResourceContentHash(-1_512_197_250)
internal val Res.string.rule_frasi_pseudoverbali_ex_arrostire: StringResource by lazy {
      StringResource("string:rule_frasi_pseudoverbali_ex_arrostire", "rule_frasi_pseudoverbali_ex_arrostire", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 243383, 93),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 240395, 89),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 241610, 113),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 231459, 89),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 225879, 89),
      ))
    }

@delegate:ResourceContentHash(-1_213_463_031)
internal val Res.string.rule_frasi_pseudoverbali_ex_oggetto: StringResource by lazy {
      StringResource("string:rule_frasi_pseudoverbali_ex_oggetto", "rule_frasi_pseudoverbali_ex_oggetto", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 243477, 131),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 240485, 135),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 241724, 143),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 231549, 131),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 225969, 131),
      ))
    }

@delegate:ResourceContentHash(1_842_785_583)
internal val Res.string.rule_frasi_pseudoverbali_ex_soggetto: StringResource by lazy {
      StringResource("string:rule_frasi_pseudoverbali_ex_soggetto", "rule_frasi_pseudoverbali_ex_soggetto", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 243609, 108),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 240621, 108),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 241868, 124),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 231681, 104),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 226101, 104),
      ))
    }

@delegate:ResourceContentHash(1_236_320_724)
internal val Res.string.rule_frasi_pseudoverbali_title: StringResource by lazy {
      StringResource("string:rule_frasi_pseudoverbali_title", "rule_frasi_pseudoverbali_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 243718, 66),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 240730, 66),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 241993, 70),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 231786, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 226206, 70),
      ))
    }

@delegate:ResourceContentHash(1_638_024_658)
internal val Res.string.rule_genere_numero_card_1: StringResource by lazy {
      StringResource("string:rule_genere_numero_card_1", "rule_genere_numero_card_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 243785, 101),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 240797, 101),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 242064, 97),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 231853, 93),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 226277, 85),
      ))
    }

@delegate:ResourceContentHash(-2_009_019_956)
internal val Res.string.rule_genere_numero_card_2: StringResource by lazy {
      StringResource("string:rule_genere_numero_card_2", "rule_genere_numero_card_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 243887, 97),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 240899, 97),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 242162, 105),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 231947, 105),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 226363, 81),
      ))
    }

@delegate:ResourceContentHash(-1_427_863_715)
internal val Res.string.rule_genere_numero_card_3: StringResource by lazy {
      StringResource("string:rule_genere_numero_card_3", "rule_genere_numero_card_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 243985, 145),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 240997, 137),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 242268, 137),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 232053, 137),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 226445, 121),
      ))
    }

@delegate:ResourceContentHash(2_124_522_717)
internal val Res.string.rule_genere_numero_card_4: StringResource by lazy {
      StringResource("string:rule_genere_numero_card_4", "rule_genere_numero_card_4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 244131, 137),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 241135, 141),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 242406, 133),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 232191, 129),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 226567, 129),
      ))
    }

@delegate:ResourceContentHash(-592_022_110)
internal val Res.string.rule_genere_numero_card_5: StringResource by lazy {
      StringResource("string:rule_genere_numero_card_5", "rule_genere_numero_card_5", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 244269, 209),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 241277, 181),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 242540, 177),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 232321, 197),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 226697, 177),
      ))
    }

@delegate:ResourceContentHash(-888_290_205)
internal val Res.string.rule_genere_numero_ex_femminile: StringResource by lazy {
      StringResource("string:rule_genere_numero_ex_femminile", "rule_genere_numero_ex_femminile", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 244611, 55),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 241583, 55),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 242854, 63),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 232647, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 227011, 55),
      ))
    }

@delegate:ResourceContentHash(1_157_245_384)
internal val Res.string.rule_genere_numero_ex_femminile_2: StringResource by lazy {
      StringResource("string:rule_genere_numero_ex_femminile_2", "rule_genere_numero_ex_femminile_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 244479, 65),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 241459, 61),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 242718, 65),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 232519, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 226875, 65),
      ))
    }

@delegate:ResourceContentHash(1_140_774_400)
internal val Res.string.rule_genere_numero_ex_femminile_3: StringResource by lazy {
      StringResource("string:rule_genere_numero_ex_femminile_3", "rule_genere_numero_ex_femminile_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 244545, 65),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 241521, 61),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 242784, 69),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 232581, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 226941, 69),
      ))
    }

@delegate:ResourceContentHash(667_467_905)
internal val Res.string.rule_genere_numero_ex_plurale: StringResource by lazy {
      StringResource("string:rule_genere_numero_ex_plurale", "rule_genere_numero_ex_plurale", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 244667, 57),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 241639, 57),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 242918, 69),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 232707, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 227067, 57),
      ))
    }

@delegate:ResourceContentHash(-1_489_325_243)
internal val Res.string.rule_genere_numero_title: StringResource by lazy {
      StringResource("string:rule_genere_numero_title", "rule_genere_numero_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 244725, 60),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 241697, 56),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 242988, 52),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 232765, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 227125, 56),
      ))
    }

@delegate:ResourceContentHash(-660_029_582)
internal val Res.string.rule_genitivo_indiretto_card_1: StringResource by lazy {
      StringResource("string:rule_genitivo_indiretto_card_1", "rule_genitivo_indiretto_card_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 244786, 214),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 241754, 166),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 243041, 174),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 232818, 158),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 227182, 166),
      ))
    }

@delegate:ResourceContentHash(-476_797_562)
internal val Res.string.rule_genitivo_indiretto_card_2: StringResource by lazy {
      StringResource("string:rule_genitivo_indiretto_card_2", "rule_genitivo_indiretto_card_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 245001, 222),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 241921, 190),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 243216, 210),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 232977, 198),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 227349, 198),
      ))
    }

@delegate:ResourceContentHash(-1_762_417_325)
internal val Res.string.rule_genitivo_indiretto_card_3: StringResource by lazy {
      StringResource("string:rule_genitivo_indiretto_card_3", "rule_genitivo_indiretto_card_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 245224, 118),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 242112, 114),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 243427, 122),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 233176, 118),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 227548, 110),
      ))
    }

@delegate:ResourceContentHash(738_404_016)
internal val Res.string.rule_genitivo_indiretto_ex_falchi_padre: StringResource by lazy {
      StringResource("string:rule_genitivo_indiretto_ex_falchi_padre", "rule_genitivo_indiretto_ex_falchi_padre", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 245343, 75),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 242227, 79),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 243550, 75),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 233295, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 227659, 75),
      ))
    }

@delegate:ResourceContentHash(-958_461_614)
internal val Res.string.rule_genitivo_indiretto_ex_falco_padre: StringResource by lazy {
      StringResource("string:rule_genitivo_indiretto_ex_falco_padre", "rule_genitivo_indiretto_ex_falco_padre", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 245419, 74),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 242307, 74),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 243626, 70),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 233367, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 227735, 74),
      ))
    }

@delegate:ResourceContentHash(-2_111_049_263)
internal val Res.string.rule_genitivo_indiretto_ex_mucca_pastore: StringResource by lazy {
      StringResource("string:rule_genitivo_indiretto_ex_mucca_pastore", "rule_genitivo_indiretto_ex_mucca_pastore", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 245494, 72),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 242382, 72),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 243697, 72),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 233438, 76),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 227810, 72),
      ))
    }

@delegate:ResourceContentHash(-1_051_645_996)
internal val Res.string.rule_genitivo_indiretto_ex_mucche_pastore: StringResource by lazy {
      StringResource("string:rule_genitivo_indiretto_ex_mucche_pastore", "rule_genitivo_indiretto_ex_mucche_pastore", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 245567, 77),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 242455, 77),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 243770, 77),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 233515, 77),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 227883, 77),
      ))
    }

@delegate:ResourceContentHash(510_344_549)
internal val Res.string.rule_genitivo_indiretto_ex_particella: StringResource by lazy {
      StringResource("string:rule_genitivo_indiretto_ex_particella", "rule_genitivo_indiretto_ex_particella", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 245711, 49),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 242603, 49),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 243918, 49),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 233663, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 228031, 49),
      ))
    }

@delegate:ResourceContentHash(-903_043_298)
internal val Res.string.rule_genitivo_indiretto_ex_particella_fem: StringResource by lazy {
      StringResource("string:rule_genitivo_indiretto_ex_particella_fem", "rule_genitivo_indiretto_ex_particella_fem", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 245645, 65),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 242533, 69),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 243848, 69),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 233593, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 227961, 69),
      ))
    }

@delegate:ResourceContentHash(931_976_297)
internal val Res.string.rule_genitivo_indiretto_title: StringResource by lazy {
      StringResource("string:rule_genitivo_indiretto_title", "rule_genitivo_indiretto_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 245761, 61),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 242653, 61),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 243968, 61),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 233713, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 228081, 61),
      ))
    }

@delegate:ResourceContentHash(1_123_257_799)
internal val Res.string.rule_genitivo_liste_nomi_card_1: StringResource by lazy {
      StringResource("string:rule_genitivo_liste_nomi_card_1", "rule_genitivo_liste_nomi_card_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 245823, 175),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 242715, 179),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 244030, 155),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 233775, 151),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 228143, 159),
      ))
    }

@delegate:ResourceContentHash(-1_539_202_964)
internal val Res.string.rule_genitivo_liste_nomi_card_2: StringResource by lazy {
      StringResource("string:rule_genitivo_liste_nomi_card_2", "rule_genitivo_liste_nomi_card_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 245999, 203),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 242895, 175),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 244186, 175),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 233927, 191),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 228303, 163),
      ))
    }

@delegate:ResourceContentHash(1_996_555_946)
internal val Res.string.rule_genitivo_liste_nomi_card_3: StringResource by lazy {
      StringResource("string:rule_genitivo_liste_nomi_card_3", "rule_genitivo_liste_nomi_card_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 246203, 163),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 243071, 147),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 244362, 159),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 234119, 135),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 228467, 147),
      ))
    }

@delegate:ResourceContentHash(-1_346_514_350)
internal val Res.string.rule_genitivo_liste_nomi_ex_lista: StringResource by lazy {
      StringResource("string:rule_genitivo_liste_nomi_ex_lista", "rule_genitivo_liste_nomi_ex_lista", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 246367, 89),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 243219, 89),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 244522, 93),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 234255, 89),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 228615, 89),
      ))
    }

@delegate:ResourceContentHash(-1_395_276_935)
internal val Res.string.rule_genitivo_liste_nomi_ex_possesso: StringResource by lazy {
      StringResource("string:rule_genitivo_liste_nomi_ex_possesso", "rule_genitivo_liste_nomi_ex_possesso", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 246457, 108),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 243309, 108),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 244616, 112),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 234345, 108),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 228705, 108),
      ))
    }

@delegate:ResourceContentHash(665_071_220)
internal val Res.string.rule_genitivo_liste_nomi_title: StringResource by lazy {
      StringResource("string:rule_genitivo_liste_nomi_title", "rule_genitivo_liste_nomi_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 246566, 70),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 243418, 78),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 244729, 74),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 234454, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 228814, 74),
      ))
    }

@delegate:ResourceContentHash(-223_267_354)
internal val Res.string.rule_imperfettivo_card_1: StringResource by lazy {
      StringResource("string:rule_imperfettivo_card_1", "rule_imperfettivo_card_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 246727, 116),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 243587, 96),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 244898, 96),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 234611, 92),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 228967, 112),
      ))
    }

@delegate:ResourceContentHash(686_357_819)
internal val Res.string.rule_imperfettivo_card_10: StringResource by lazy {
      StringResource("string:rule_imperfettivo_card_10", "rule_imperfettivo_card_10", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 246637, 89),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 243497, 89),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 244804, 93),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 234525, 85),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 228889, 77),
      ))
    }

@delegate:ResourceContentHash(1_955_019_617)
internal val Res.string.rule_imperfettivo_card_2: StringResource by lazy {
      StringResource("string:rule_imperfettivo_card_2", "rule_imperfettivo_card_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 246844, 88),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 243684, 88),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 244995, 92),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 234704, 84),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 229080, 76),
      ))
    }

@delegate:ResourceContentHash(-2_042_951_141)
internal val Res.string.rule_imperfettivo_card_3: StringResource by lazy {
      StringResource("string:rule_imperfettivo_card_3", "rule_imperfettivo_card_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 246933, 168),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 243773, 156),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 245088, 160),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 234789, 160),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 229157, 136),
      ))
    }

@delegate:ResourceContentHash(-446_353_756)
internal val Res.string.rule_imperfettivo_card_4: StringResource by lazy {
      StringResource("string:rule_imperfettivo_card_4", "rule_imperfettivo_card_4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 247102, 92),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 243930, 92),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 245249, 92),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 234950, 88),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 229294, 80),
      ))
    }

@delegate:ResourceContentHash(331_790_400)
internal val Res.string.rule_imperfettivo_card_5: StringResource by lazy {
      StringResource("string:rule_imperfettivo_card_5", "rule_imperfettivo_card_5", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 247195, 88),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 244023, 88),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 245342, 92),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 235039, 84),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 229375, 76),
      ))
    }

@delegate:ResourceContentHash(-1_439_606_629)
internal val Res.string.rule_imperfettivo_card_6: StringResource by lazy {
      StringResource("string:rule_imperfettivo_card_6", "rule_imperfettivo_card_6", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 247284, 152),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 244112, 140),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 245435, 140),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 235124, 140),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 229452, 128),
      ))
    }

@delegate:ResourceContentHash(-163_698_464)
internal val Res.string.rule_imperfettivo_card_7: StringResource by lazy {
      StringResource("string:rule_imperfettivo_card_7", "rule_imperfettivo_card_7", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 247437, 96),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 244253, 96),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 245576, 100),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 235265, 92),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 229581, 84),
      ))
    }

@delegate:ResourceContentHash(-1_985_380_260)
internal val Res.string.rule_imperfettivo_card_8: StringResource by lazy {
      StringResource("string:rule_imperfettivo_card_8", "rule_imperfettivo_card_8", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 247534, 88),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 244350, 88),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 245677, 92),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 235358, 84),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 229666, 76),
      ))
    }

@delegate:ResourceContentHash(-794_683_207)
internal val Res.string.rule_imperfettivo_card_9: StringResource by lazy {
      StringResource("string:rule_imperfettivo_card_9", "rule_imperfettivo_card_9", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 247623, 108),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 244439, 104),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 245770, 108),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 235443, 112),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 229743, 112),
      ))
    }

@delegate:ResourceContentHash(-525_307_320)
internal val Res.string.rule_imperfettivo_ex_2gem: StringResource by lazy {
      StringResource("string:rule_imperfettivo_ex_2gem", "rule_imperfettivo_ex_2gem", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 247732, 77),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 244544, 73),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 245879, 77),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 235556, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 229856, 73),
      ))
    }

@delegate:ResourceContentHash(1_879_847_807)
internal val Res.string.rule_imperfettivo_ex_3inf: StringResource by lazy {
      StringResource("string:rule_imperfettivo_ex_3inf", "rule_imperfettivo_ex_3inf", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 247810, 77),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 244618, 69),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 245957, 77),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 235630, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 229930, 77),
      ))
    }

@delegate:ResourceContentHash(-1_158_361_351)
internal val Res.string.rule_imperfettivo_ex_4aeinf: StringResource by lazy {
      StringResource("string:rule_imperfettivo_ex_4aeinf", "rule_imperfettivo_ex_4aeinf", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 247888, 87),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 244688, 83),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 246035, 87),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 235704, 83),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 230008, 87),
      ))
    }

@delegate:ResourceContentHash(-1_246_264_385)
internal val Res.string.rule_imperfettivo_title: StringResource by lazy {
      StringResource("string:rule_imperfettivo_title", "rule_imperfettivo_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 247976, 47),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 244772, 47),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 246123, 47),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 235788, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 230096, 47),
      ))
    }

@delegate:ResourceContentHash(1_336_895_659)
internal val Res.string.rule_infinito_card_1: StringResource by lazy {
      StringResource("string:rule_infinito_card_1", "rule_infinito_card_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 248090, 176),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 244882, 200),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 246237, 208),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 235898, 192),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 230206, 200),
      ))
    }

@delegate:ResourceContentHash(-1_500_437_003)
internal val Res.string.rule_infinito_card_10: StringResource by lazy {
      StringResource("string:rule_infinito_card_10", "rule_infinito_card_10", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 248024, 65),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 244820, 61),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 246171, 65),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 235836, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 230144, 61),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString23Resources(map: MutableMap<String, StringResource>) {
  map.put("reminder_open_exact_alarm_settings", Res.string.reminder_open_exact_alarm_settings)
  map.put("reminder_open_permissions", Res.string.reminder_open_permissions)
  map.put("reminder_settings_choose", Res.string.reminder_settings_choose)
  map.put("reminder_settings_desc", Res.string.reminder_settings_desc)
  map.put("reminder_settings_title", Res.string.reminder_settings_title)
  map.put("reminder_settings_toggle_desc", Res.string.reminder_settings_toggle_desc)
  map.put("reminder_settings_toggle_title", Res.string.reminder_settings_toggle_title)
  map.put("remove_hearts_btn", Res.string.remove_hearts_btn)
  map.put("repeat_quizzes_hint", Res.string.repeat_quizzes_hint)
  map.put("request_more_lessons_btn", Res.string.request_more_lessons_btn)
  map.put("request_more_lessons_email_body", Res.string.request_more_lessons_email_body)
  map.put("request_more_lessons_email_subject", Res.string.request_more_lessons_email_subject)
  map.put("reset_btn", Res.string.reset_btn)
  map.put("reset_data_btn", Res.string.reset_data_btn)
  map.put("reset_data_confirm", Res.string.reset_data_confirm)
  map.put("reset_data_dialog_text", Res.string.reset_data_dialog_text)
  map.put("reset_data_dialog_title", Res.string.reset_data_dialog_title)
  map.put("restore_purchases_btn", Res.string.restore_purchases_btn)
  map.put("review_prompt_btn_later", Res.string.review_prompt_btn_later)
  map.put("review_prompt_btn_rate", Res.string.review_prompt_btn_rate)
  map.put("review_prompt_feedback", Res.string.review_prompt_feedback)
  map.put("review_prompt_title", Res.string.review_prompt_title)
  map.put("rule_aggettivi_card_1", Res.string.rule_aggettivi_card_1)
  map.put("rule_aggettivi_card_2", Res.string.rule_aggettivi_card_2)
  map.put("rule_aggettivi_card_3", Res.string.rule_aggettivi_card_3)
  map.put("rule_aggettivi_card_4", Res.string.rule_aggettivi_card_4)
  map.put("rule_aggettivi_ex_nfr", Res.string.rule_aggettivi_ex_nfr)
  map.put("rule_aggettivi_ex_nfrt", Res.string.rule_aggettivi_ex_nfrt)
  map.put("rule_aggettivi_ex_rmt_nfr", Res.string.rule_aggettivi_ex_rmt_nfr)
  map.put("rule_aggettivi_ex_rmtw_nfrw", Res.string.rule_aggettivi_ex_rmtw_nfrw)
  map.put("rule_aggettivi_ex_smsw_iqr", Res.string.rule_aggettivi_ex_smsw_iqr)
  map.put("rule_aggettivi_ex_st_nfrt", Res.string.rule_aggettivi_ex_st_nfrt)
  map.put("rule_aggettivi_ex_swt_nfrwt", Res.string.rule_aggettivi_ex_swt_nfrwt)
  map.put("rule_aggettivi_title", Res.string.rule_aggettivi_title)
  map.put("rule_dimostrativi_card_1", Res.string.rule_dimostrativi_card_1)
  map.put("rule_dimostrativi_card_2", Res.string.rule_dimostrativi_card_2)
  map.put("rule_dimostrativi_card_3", Res.string.rule_dimostrativi_card_3)
  map.put("rule_dimostrativi_ex_nn", Res.string.rule_dimostrativi_ex_nn)
  map.put("rule_dimostrativi_ex_pn", Res.string.rule_dimostrativi_ex_pn)
  map.put("rule_dimostrativi_ex_srw_pn", Res.string.rule_dimostrativi_ex_srw_pn)
  map.put("rule_dimostrativi_ex_tn", Res.string.rule_dimostrativi_ex_tn)
  map.put("rule_dimostrativi_title", Res.string.rule_dimostrativi_title)
  map.put("rule_frasi_avverbiali_card_1", Res.string.rule_frasi_avverbiali_card_1)
  map.put("rule_frasi_avverbiali_card_2", Res.string.rule_frasi_avverbiali_card_2)
  map.put("rule_frasi_avverbiali_card_3", Res.string.rule_frasi_avverbiali_card_3)
  map.put("rule_frasi_avverbiali_card_4", Res.string.rule_frasi_avverbiali_card_4)
  map.put("rule_frasi_avverbiali_card_5", Res.string.rule_frasi_avverbiali_card_5)
  map.put("rule_frasi_avverbiali_ex_iht_pr", Res.string.rule_frasi_avverbiali_ex_iht_pr)
  map.put("rule_frasi_avverbiali_ex_iw", Res.string.rule_frasi_avverbiali_ex_iw)
  map.put("rule_frasi_avverbiali_title", Res.string.rule_frasi_avverbiali_title)
  map.put("rule_frasi_pseudoverbali_card_1", Res.string.rule_frasi_pseudoverbali_card_1)
  map.put("rule_frasi_pseudoverbali_card_2", Res.string.rule_frasi_pseudoverbali_card_2)
  map.put("rule_frasi_pseudoverbali_card_3", Res.string.rule_frasi_pseudoverbali_card_3)
  map.put("rule_frasi_pseudoverbali_card_4", Res.string.rule_frasi_pseudoverbali_card_4)
  map.put("rule_frasi_pseudoverbali_ex_arrostire", Res.string.rule_frasi_pseudoverbali_ex_arrostire)
  map.put("rule_frasi_pseudoverbali_ex_oggetto", Res.string.rule_frasi_pseudoverbali_ex_oggetto)
  map.put("rule_frasi_pseudoverbali_ex_soggetto", Res.string.rule_frasi_pseudoverbali_ex_soggetto)
  map.put("rule_frasi_pseudoverbali_title", Res.string.rule_frasi_pseudoverbali_title)
  map.put("rule_genere_numero_card_1", Res.string.rule_genere_numero_card_1)
  map.put("rule_genere_numero_card_2", Res.string.rule_genere_numero_card_2)
  map.put("rule_genere_numero_card_3", Res.string.rule_genere_numero_card_3)
  map.put("rule_genere_numero_card_4", Res.string.rule_genere_numero_card_4)
  map.put("rule_genere_numero_card_5", Res.string.rule_genere_numero_card_5)
  map.put("rule_genere_numero_ex_femminile", Res.string.rule_genere_numero_ex_femminile)
  map.put("rule_genere_numero_ex_femminile_2", Res.string.rule_genere_numero_ex_femminile_2)
  map.put("rule_genere_numero_ex_femminile_3", Res.string.rule_genere_numero_ex_femminile_3)
  map.put("rule_genere_numero_ex_plurale", Res.string.rule_genere_numero_ex_plurale)
  map.put("rule_genere_numero_title", Res.string.rule_genere_numero_title)
  map.put("rule_genitivo_indiretto_card_1", Res.string.rule_genitivo_indiretto_card_1)
  map.put("rule_genitivo_indiretto_card_2", Res.string.rule_genitivo_indiretto_card_2)
  map.put("rule_genitivo_indiretto_card_3", Res.string.rule_genitivo_indiretto_card_3)
  map.put("rule_genitivo_indiretto_ex_falchi_padre", Res.string.rule_genitivo_indiretto_ex_falchi_padre)
  map.put("rule_genitivo_indiretto_ex_falco_padre", Res.string.rule_genitivo_indiretto_ex_falco_padre)
  map.put("rule_genitivo_indiretto_ex_mucca_pastore", Res.string.rule_genitivo_indiretto_ex_mucca_pastore)
  map.put("rule_genitivo_indiretto_ex_mucche_pastore", Res.string.rule_genitivo_indiretto_ex_mucche_pastore)
  map.put("rule_genitivo_indiretto_ex_particella", Res.string.rule_genitivo_indiretto_ex_particella)
  map.put("rule_genitivo_indiretto_ex_particella_fem", Res.string.rule_genitivo_indiretto_ex_particella_fem)
  map.put("rule_genitivo_indiretto_title", Res.string.rule_genitivo_indiretto_title)
  map.put("rule_genitivo_liste_nomi_card_1", Res.string.rule_genitivo_liste_nomi_card_1)
  map.put("rule_genitivo_liste_nomi_card_2", Res.string.rule_genitivo_liste_nomi_card_2)
  map.put("rule_genitivo_liste_nomi_card_3", Res.string.rule_genitivo_liste_nomi_card_3)
  map.put("rule_genitivo_liste_nomi_ex_lista", Res.string.rule_genitivo_liste_nomi_ex_lista)
  map.put("rule_genitivo_liste_nomi_ex_possesso", Res.string.rule_genitivo_liste_nomi_ex_possesso)
  map.put("rule_genitivo_liste_nomi_title", Res.string.rule_genitivo_liste_nomi_title)
  map.put("rule_imperfettivo_card_1", Res.string.rule_imperfettivo_card_1)
  map.put("rule_imperfettivo_card_10", Res.string.rule_imperfettivo_card_10)
  map.put("rule_imperfettivo_card_2", Res.string.rule_imperfettivo_card_2)
  map.put("rule_imperfettivo_card_3", Res.string.rule_imperfettivo_card_3)
  map.put("rule_imperfettivo_card_4", Res.string.rule_imperfettivo_card_4)
  map.put("rule_imperfettivo_card_5", Res.string.rule_imperfettivo_card_5)
  map.put("rule_imperfettivo_card_6", Res.string.rule_imperfettivo_card_6)
  map.put("rule_imperfettivo_card_7", Res.string.rule_imperfettivo_card_7)
  map.put("rule_imperfettivo_card_8", Res.string.rule_imperfettivo_card_8)
  map.put("rule_imperfettivo_card_9", Res.string.rule_imperfettivo_card_9)
  map.put("rule_imperfettivo_ex_2gem", Res.string.rule_imperfettivo_ex_2gem)
  map.put("rule_imperfettivo_ex_3inf", Res.string.rule_imperfettivo_ex_3inf)
  map.put("rule_imperfettivo_ex_4aeinf", Res.string.rule_imperfettivo_ex_4aeinf)
  map.put("rule_imperfettivo_title", Res.string.rule_imperfettivo_title)
  map.put("rule_infinito_card_1", Res.string.rule_infinito_card_1)
  map.put("rule_infinito_card_10", Res.string.rule_infinito_card_10)
}
